<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
const presentation = usePresentation();
presentation.registerTrigger();

</script><template>

    <Page>

        <div class="grid grid-cols-12 justify-center items-center gap-16 w-full">

            <div class="col-span-6">

                <div class="mb-1 text-lg 4xl:text-2xl text-white text-center font-semibold">Real benefits for the customer</div>
                <div class="mb-6 text-sm 4xl:text-base text-white text-center">Covered Items Limits (Per Work Order) Parts and Labour excluding VAT</div>

                <table class="
                    uppercase text-sm 2xl:text-sm 3xl:text-base text-center w-full 
                    border-separate rounded-lg ring-4 ring-white shadow-xl">
            
                    <tbody>

                        <tr class="font-semibold text-sm">
                            <td class="bg-indigo-600 rounded-tl-lg p-1 lg:p-2 text-left">Item</td>
                            <td class="bg-indigo-600 p-1 md:p-4">Cat<br/>1</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Cat<br/>2</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Cat<br/>3</td>
                            <td class="bg-indigo-600 rounded-tr-lg p-1 md:p-4">Cat<br/>4</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Key Fob Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £432
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £285
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £490
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £490
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Brake Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £245
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £238
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £451
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £490
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Wiper Blades
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £43
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £40
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £460
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £96
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Battery Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £167
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £167
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £272
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £490
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Tyre Repair
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £18
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £18
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £21
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £27
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Tyre Replacement (per tyre)
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £143
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £143
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £174
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £490
                            </td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-sm 2xl:text-sm">
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2 text-left leading-tight">Max claim amount<br/>over 3 year contract</td>
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2">£3,108 <div v-if="presentation.currentTrigger == 0" class="w-full h-full top-0 left-0 absolute flex items-center justify-center z-10"><div class="scale-125 rounded-full w-full aspect-square border-[5px] border-red-500"></div></div></td>
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2 border-gray-950">£2,503</td>
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2  border-gray-950">£4,002</td>
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2">£5,648</td>
                        </tr>

                    </tbody>

                </table>

                <div class="mt-6 text-sm 2xl:text-base text-white text-center" 
                     :class="presentation.currentTrigger == 0 ? 'opacity-100' : 'opacity-0'">
                    What's in it for the customer
                </div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

            <div class="col-span-6">

                <div class="mb-1 text-lg 4xl:text-2xl text-white text-center font-semibold">Real benefits for the dealership</div>
                <div class="mb-6 text-sm 4xl:text-base text-white text-center">Potential Labour rate per item, per category, per policy</div>

                <table class="
                    uppercase text-sm md:text-sm 2xl:text-base 3xl:text-lg text-center w-full 
                    border-separate rounded-lg ring-4 ring-white shadow-xl">
            
                    <tbody>

                        <tr class="font-semibold text-sm">
                            <td class="bg-indigo-600 rounded-tl-lg p-1 lg:p-2 text-left">Item</td>
                            <td class="bg-indigo-600 p-1 md:p-4">Cat<br/>1</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Cat<br/>2</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Cat<br/>3</td>
                            <td class="bg-indigo-600 rounded-tr-lg p-1 md:p-4">Cat<br/>4</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Key Fob Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £353
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £353
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £412
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £530
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Brake Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £353
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £353
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £412
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £530
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Wiper Blades
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £360
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £36
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £42
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £53
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Battery Replacement
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £45
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £45
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £52
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £67
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Tyre Repair
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £106
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £106
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £124
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £159
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm text-left">
                                Tyre Replacement (per tyre)
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £177
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £177
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £206
                            </td>
                            <td class="bg-white text-black p-1 lg:p-2 text-sm 3xl:text-sm">
                                £265
                            </td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-sm 2xl:text-sm">
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2 text-left leading-tight">Additional profit<br/>from work orders</td>
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2">£1,070 <div v-if="presentation.currentTrigger == 0" class="w-full h-full top-0 left-0 absolute flex items-center justify-center z-10"><div class="scale-125 rounded-full w-full aspect-square border-[5px] border-red-500"></div></div></td>
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2 border-gray-950">£1,070</td>
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2  border-gray-950">£1,248</td>
                            <td class="bg-emerald-300 text-emerald-700 p-1 lg:p-2">£1,604</td>
                        </tr>
                    
                    </tbody>
                    
                </table>

                <div class="mt-6 text-sm 2xl:text-base text-white text-center" 
                     :class="presentation.currentTrigger == 0 ? 'opacity-100' : 'opacity-0'">
                     What's in it for <span class="uppercase font-bold text-emerald-400">the dealers</span> bottom line
                    </div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

        </div>


    </Page>

</template>